import { reduxKey } from './constants';
export var ChatServiceStatus;
(function (ChatServiceStatus) {
    ChatServiceStatus["ONLINE"] = "online";
    ChatServiceStatus["OFFLINE"] = "offline";
})(ChatServiceStatus || (ChatServiceStatus = {}));
export var ChatPageType;
(function (ChatPageType) {
    ChatPageType["OVERLAY"] = "overlay";
    ChatPageType["FULLPAGE"] = "fullpage";
})(ChatPageType || (ChatPageType = {}));
export var ChatParticipantDisplayDataTypes;
(function (ChatParticipantDisplayDataTypes) {
    ChatParticipantDisplayDataTypes["ROOM"] = "room";
    ChatParticipantDisplayDataTypes["USER"] = "user";
    ChatParticipantDisplayDataTypes["MULTI"] = "multichat";
})(ChatParticipantDisplayDataTypes || (ChatParticipantDisplayDataTypes = {}));
export var ChatLabels;
(function (ChatLabels) {
    ChatLabels["ACTIVE"] = "42bfc914-8ae3-4525-8b49-32236b824b19";
    ChatLabels["REQUESTS"] = "7eeeb607-2a32-46e1-b71d-480e4c0b8c3c";
    ChatLabels["DEVIATION"] = "f84b38ba-a32c-4dc6-bc76-4a7585fa7995";
    ChatLabels["GROUP"] = "af06db63-fafc-4c86-86f5-1f49a7e9610c";
})(ChatLabels || (ChatLabels = {}));
export var ChatroomScrollEvent;
(function (ChatroomScrollEvent) {
    ChatroomScrollEvent["NEW_MESSAGE"] = "new_message";
    ChatroomScrollEvent["SEND_MESSAGE"] = "send_message";
    ChatroomScrollEvent["TYPING_INDICATOR"] = "typing_indicator";
    ChatroomScrollEvent["INITIAL_OPEN"] = "initial_open";
    ChatroomScrollEvent["WINDOW_TOGGLE"] = "window_toggle";
    ChatroomScrollEvent["MEDIA_BAR"] = "media_bar";
    ChatroomScrollEvent["LOAD_MORE"] = "load_more";
    ChatroomScrollEvent["EDITOR_FOCUS"] = "editor_focus";
})(ChatroomScrollEvent || (ChatroomScrollEvent = {}));
export var NewChatRequestStatus;
(function (NewChatRequestStatus) {
    NewChatRequestStatus["PRESUBMIT"] = "presubmit";
    NewChatRequestStatus["INITIALIZING"] = "initializing";
    NewChatRequestStatus["CREATING"] = "creating";
    NewChatRequestStatus["ERROR"] = "error";
})(NewChatRequestStatus || (NewChatRequestStatus = {}));
export var NewChatRequestSource;
(function (NewChatRequestSource) {
    NewChatRequestSource["CREATE_GROUP_CHAT"] = "create_group_chat";
    NewChatRequestSource["NEW_CHAT_WINDOW"] = "new_chat_window";
})(NewChatRequestSource || (NewChatRequestSource = {}));
export var ChatListSubscriptionStatus;
(function (ChatListSubscriptionStatus) {
    ChatListSubscriptionStatus["LOADING"] = "loading";
    ChatListSubscriptionStatus["LISTENING"] = "listening";
    ChatListSubscriptionStatus["ERROR"] = "error";
    ChatListSubscriptionStatus["NONE"] = "none";
})(ChatListSubscriptionStatus || (ChatListSubscriptionStatus = {}));
//# sourceMappingURL=types.js.map